angular.module("clientDataNew.components", [])
  .component("clientDataNew", {
    templateUrl: "ng/components/clientDataNew/clientDataNew.view.html",
    bindings: {
      identifier: "<",
      clientData: "=",
      nextStepIsEnabled: "=",
      cervedUpdate: "=",
      onComplete: "&?",
      panelClass: "=",
      //Optional
      onClientDataNewOk: "&?",
      onClientDataNewNotOk: "&?",
      ndg: "<"
    },
    controllerAs: "clientDataNewCtrl",
    controller: function clientDataNewController(
      $featureService,
      $rootScope,
      $filter,
      $scope,
      HttpService,
      $timeout,
      $translate,
      $modalService,
      $searchUserService,
      $cervedService,
      RiUserG,
      $istatService
    ) {
      var self = this;
      self.getIsNewG = function () {
        return false;
      };

      /**
       * Init component
       **/
      self.$onInit = function () {


        self.identifier = self.identifier || null;
        self.clientData = self.clientData || null;
        $scope.raccoltaInfo.datiSocietari = RiUserG.build(self.clientData);

        self.cervedUpdate = 0;

        $scope.raccoltaInfo.datiSocietari.updateFromCerved = false;

        $scope.raccoltaInfo.datiSocietari.sae2 =
          $scope.raccoltaInfo.datiSocietari.sae;
        $scope.raccoltaInfo.datiSocietari.rae2 =
          $scope.raccoltaInfo.datiSocietari.rae;
        $scope.raccoltaInfo.datiSocietari.emailPec2 =
          $scope.raccoltaInfo.datiSocietari.emailPec;

        if (
          $scope.raccoltaInfo.datiSocietari.telefono &&
          $scope.raccoltaInfo.datiSocietari.telefono.indexOf("/") != -1 &&
          $scope.raccoltaInfo.datiSocietari.updateFromCerved &&
          !$scope.raccoltaInfo.datiSocietari.telefono
        ) {
          var splittedPhone = $scope.raccoltaInfo.datiSocietari.telefono.split(
            "/"
          );
          //$scope.configObj.telPrefix = splittedPhone[0];
          $scope.raccoltaInfo.datiSocietari.telefono = splittedPhone[1];
        }

        /**
         * Initialize - ex initializeMandatoryModelInformation
         */

        $scope.nazioniEstere = nazEsteraMap;
        $scope.mapComuni = $rootScope.comuniMap;
        $scope.listaProvince = {};
        $scope.citiesList = {
          sedeLegale: [],
          sedeConsegna: [],
          fatturazione: [],
          residenza: []
        };
        $scope.capList = {
          sedeLegale: [],
          sedeConsegna: [],
          fatturazione: [],
          residenza: []
        };

        $scope.dropdown = {
          stati: [],
          statiEsteri: [], // "!ITALIA"
          legalStatuses: []
        };

        self.createListaProvince();

        $scope.dataFromCerved = true;

        $istatService.getNazioni()
          .then(function (response) {
            $scope.dropdown.stati = response.domainList;
            $scope.dropdown.statiEsteri = response.domainList.filter(
              function (elem) {
                return elem.name != "ITALIA";
              }
            );
            self.verifyUserGAddress();
          });

        self.getCities(
          "sedeLegale",
          $scope.raccoltaInfo.datiSocietari.sedeLegale.provincia
        );

        self.getCities(
          "sedeConsegna",
          $scope.raccoltaInfo.datiSocietari.sedeConsegna.provincia
        );

        self.getCities(
          "fatturazione",
          $scope.raccoltaInfo.datiSocietari.fatturazione.provincia
        );

        self.getLegalStatuses();

        if ($scope.raccoltaInfo.datiSocietari.formaGiuridica) {
          self.getSaeList(
            false,
            $scope.raccoltaInfo.datiSocietari.formaGiuridica,
            false
          );
        }

        self.clientDataNew = Object.assign({}, $scope.raccoltaInfo.datiSocietari);

        self.nextStepIsEnabled = $scope.change();


        //controllo se è un nuovo utente ed in tal caso forzo ad effettuare l'aggiornamento
        $timeout(function cervedUpdate() {
          self.aggiorna();
        }, 500);

      };

      self.aggiorna = function () {
        if (self.ndg == "") {
          console.log("cerved update needed!");
          $modalService.openModal('requiredCervedUpdate');
          console.log('Ho eseguito la modale');
        }
      };

      self.createListaProvince = function () {
        const CERVED_NATION_EE = "EE";
        $scope.listaProvince = [];

        $scope.mapComuni.forEach(function (comune) {
          if ($scope.listaProvince.indexOf(comune.sigla) == -1) {
            $scope.listaProvince.push(comune.sigla);
          }
        });
        $scope.listaProvince.push(CERVED_NATION_EE);
      };




      /**
       * Cerved
       **/
      self.getUpdatedDataFromCerved = function () {
        self.cervedUpdate = 5;
        var identifier = self.identifier;
        $cervedService
          .getCustomer(identifier)
          .then(function (response) {
            const CERVED_NATION_ITALY = "ITALIA";
            const CERVED_NATION_EE = "EE";
            $scope.cervedData = response;
            console.log(
              "$cervedService.getCustomer(identifier) - service",
              response
            );
            if (response.success) {
              var riUserG = Object.assign({},
                $scope.cervedData.appCustomerUser.metadata.riUserG
              );
              if (!riUserG.sedeLegale.stato) {
                riUserG.sedeLegale.stato = CERVED_NATION_ITALY;
              }
              if (riUserG.sedeLegale.provincia != CERVED_NATION_EE) {
                riUserG.sedeLegale.indirizzo =
                  riUserG.sedeLegale.typeStreet +
                  " " +
                  riUserG.sedeLegale.indirizzo;
                riUserG.sedeLegale.stato = CERVED_NATION_ITALY;
              }
              if (riUserG.fatturazione.provincia != CERVED_NATION_EE) {
                riUserG.fatturazione.indirizzo =
                  riUserG.fatturazione.typeStreet +
                  " " +
                  riUserG.fatturazione.indirizzo;
                riUserG.fatturazione.stato = CERVED_NATION_ITALY;
              }
              if (riUserG.sedeConsegna) {
                if (riUserG.sedeConsegna.provincia != CERVED_NATION_EE) {
                  riUserG.sedeConsegna.indirizzo =
                    riUserG.sedeConsegna.typeStreet +
                    " " +
                    riUserG.sedeConsegna.indirizzo;
                  riUserG.sedeConsegna.stato = CERVED_NATION_ITALY;
                }
              } else {
                riUserG.sedeConsegna = riUserG.sedeLegale;
              }

              if (riUserG.listExtIndirizzi[0].province != CERVED_NATION_EE) {
                riUserG.listExtIndirizzi[0].street =
                  riUserG.listExtIndirizzi[0].type +
                  " " +
                  riUserG.listExtIndirizzi[0].street;
                console.log(
                  "riUserG.listExtIndirizzi[0].street",
                  riUserG.listExtIndirizzi[0].street
                );
                //	riUserG.listExtIndirizzi[0].stato = CERVED_NATION_ITALY;
              }

              if (
                //$scope.configObj.isNewG &&
                $scope.getIsNewG(riUserG.sae, riUserG.rae)
              ) {
                self.cervedUpdate = 0;
                $scope.cervedData.appCustomerUser.metadata.riUserG = Object.assign(
                  $scope.cervedData.appCustomerUser.metadata.riUserG,
                  riUserG
                );
                self.onComplete();
              }

              if (riUserG.formaGiuridica) {
                self.getSaeList(false, riUserG.formaGiuridica, true);
              }
              $scope.raccoltaInfo.datiSocietari.sae2 =
                $scope.raccoltaInfo.datiSocietari.sae;
              $scope.raccoltaInfo.datiSocietari.rae2 =
                $scope.raccoltaInfo.datiSocietari.rae;
            } else {
              //No results
              if (
                response.keyMessage == "ERROR_NO_RESULTS" &&
                $searchUserService.forcedCervedUpdate()
              ) {
                $modalService.openModal("noCervedData");
              }
              if (
                response.keyMessage == "ERROR_NO_RESULTS" &&
                $searchUserService.forcedCervedUpdate() == false
              ) {
                $rootScope.$broadcast("addAlert", {
                  text: "ERROR_NO_RESULTS"
                });
                self.cervedUpdate = 0;
              }
              if (self.cervedUpdate == 5) {
                self.cervedUpdate = 0;
              }
            }
          })
          .catch(function () {
            if ($searchUserService.forcedCervedUpdate()) {
              $modalService.openModal("cervedDown");
            }
          });
      };

      self.saveUpdatedData = function () {
        var riUserG = Object.assign({},
          $scope.cervedData.appCustomerUser.metadata.riUserG
        );

        if ($scope.dropdown.saeFromCerved) {
          $scope.dropdown.sae = $scope.dropdown.saeFromCerved.slice();
        }
        if ($scope.dropdown.raeFromCerved) {
          $scope.dropdown.rae = $scope.dropdown.raeFromCerved.slice();
        }

        $scope.raccoltaInfo.datiSocietari.sae2 =
          $scope.raccoltaInfo.datiSocietari.sae;
        $scope.raccoltaInfo.datiSocietari.rae2 =
          $scope.raccoltaInfo.datiSocietari.rae;
        $scope.raccoltaInfo.datiSocietari.emailPec2 =
          $scope.raccoltaInfo.datiSocietari.emailPec;

        var updatedProperties = [
          "piva",
          "telefono",
          "ragioneSociale",
          "formaGiuridica",
          "sae",
          "rae",
          "ccia",
          "cf",
          "emailPec",
          "ateco",
          "dataAvvioAttivita",
          "dataCostituzioneSocieta"
        ];
        updatedProperties.forEach(function (prop) {
          if (riUserG[prop] && riUserG[prop] != "-") {
            if (
              prop === "telefono" &&
              ($scope.raccoltaInfo.datiSocietari.updateFromCerved &&
                !$scope.raccoltaInfo.datiSocietari.telefono) &&
              riUserG.telefono.indexOf("/") != -1
            ) {
              var splittedPhone = riUserG.telefono.split("/");
              $scope.raccoltaInfo.datiSocietari.telefono = splittedPhone[1];
            } else {
              $scope.raccoltaInfo.datiSocietari[prop] = riUserG[prop];
              if (prop === "sae") {
                self.getSaeList(
                  false,
                  $scope.raccoltaInfo.datiSocietari.formaGiuridica,
                  false
                );
              }
            }
          }
          $scope.cervedData.appCustomerUser.metadata.riUserG = Object.assign(
            $scope.cervedData.appCustomerUser.metadata.riUserG,
            riUserG
          );
        });

        $scope.raccoltaInfo.datiSocietari.sedeLegale = Object.assign(
          $scope.raccoltaInfo.datiSocietari.sedeLegale,
          riUserG.sedeLegale
        );
        console.log(
          "sedeLegale1: ",
          $scope.raccoltaInfo.datiSocietari.sedeLegale
        );

        if (riUserG.sedeLegale.provincia) {
          self.getCities("sedeLegale", riUserG.sedeLegale.provincia);
        }
        if (riUserG.sedeLegale.comune) {
          var comune = $scope.mapComuni.find(function (el) {
            return (
              el.nome.toUpperCase() === riUserG.sedeLegale.comune.toUpperCase()
            );
          });
          if (comune) {
            comune = comune.nome;
          }
          $scope.raccoltaInfo.datiSocietari.sedeLegale.comune = comune;
          self.getCaps(
            "sedeLegale",
            $scope.raccoltaInfo.datiSocietari.sedeLegale.comune
          );
        }

        function fixMunicipalityName(municipality) {
          municipality = municipality.toUpperCase();
          return municipality
            .replace("A'", "À")
            .replace("E'", "È")
            .replace("I'", "Ì")
            .replace("O'", "Ò")
            .replace("U'", "Ù");
        }

        if (riUserG.listExtIndirizzi.length) {
          $scope.raccoltaInfo.datiSocietari.listExtIndirizzi =
            riUserG.listExtIndirizzi;
          $scope.raccoltaInfo.datiSocietari.listExtIndirizzi = $scope.raccoltaInfo.datiSocietari.listExtIndirizzi.map(
            function (address) {
              address.municipality = fixMunicipalityName(address.municipality);
              var comune = $scope.mapComuni.find(function (el) {
                return (
                  el.nome.toUpperCase() === address.municipality.toUpperCase()
                );
              });

              if (comune) {
                comune = comune.nome;
              } else {
                // if no municipality is found, search if there is one with the post code provided by Cerved (may be possible, if the municipality is in comuni.json but is spelled in a slightly different way)
                if (address.postCode) {
                  var municipalitiesFromPostCode = $scope.mapComuni.filter(
                    function (el) {
                      return el.cap.indexOf(address.postCode) != -1;
                    }
                  );
                  if (
                    municipalitiesFromPostCode &&
                    municipalitiesFromPostCode.length == 1
                  ) {
                    comune = municipalitiesFromPostCode[0].nome;
                  } else {
                    // if more than one municipality is found for that post code, leave the field blank
                    comune = "";
                  }
                }
              }

              return {
                comune: comune,
                cap: address.postCode,
                provincia: address.province,
                numeroCivico: address.civicNumber,
                indirizzo: address.street,
                stato: "ITALIA"
              };
            }
          );

          if ($scope.raccoltaInfo.datiSocietari.listExtIndirizzi.length == 1) {
            Object.assign(
              $scope.raccoltaInfo.datiSocietari.sedeConsegna,
              $scope.raccoltaInfo.datiSocietari.listExtIndirizzi[0]
            );

            if ($scope.raccoltaInfo.datiSocietari.listExtIndirizzi[0].provincia) {
              self.getCities(
                "sedeConsegna",
                $scope.raccoltaInfo.datiSocietari.listExtIndirizzi[0].provincia
              );
            }
            if ($scope.raccoltaInfo.datiSocietari.listExtIndirizzi[0].comune) {
              var comune = $scope.mapComuni.find(function (el) {
                return (
                  el.nome.toUpperCase() ===
                  $scope.raccoltaInfo.datiSocietari.listExtIndirizzi[0].comune.toUpperCase()
                );
              });
              if (comune) {
                comune = comune.nome;
              }
              $scope.raccoltaInfo.datiSocietari.sedeConsegna.comune = comune;
              self.getCaps(
                "sedeConsegna",
                $scope.raccoltaInfo.datiSocietari.sedeConsegna.comune
              );
            }

            // FATTURAZIONE

            Object.assign(
              $scope.raccoltaInfo.datiSocietari.fatturazione,
              $scope.raccoltaInfo.datiSocietari.listExtIndirizzi[0]
            );

            if ($scope.raccoltaInfo.datiSocietari.listExtIndirizzi[0].provincia) {
              self.getCities(
                "fatturazione",
                $scope.raccoltaInfo.datiSocietari.listExtIndirizzi[0].provincia
              );
            }
            if ($scope.raccoltaInfo.datiSocietari.listExtIndirizzi[0].comune) {
              var comune = $scope.mapComuni.find(function (el) {
                return (
                  el.nome.toUpperCase() ===
                  $scope.raccoltaInfo.datiSocietari.listExtIndirizzi[0].comune.toUpperCase()
                );
              });
              if (comune) {
                comune = comune.nome;
              }
              $scope.raccoltaInfo.datiSocietari.fatturazione.comune = comune;
              self.getCaps(
                "fatturazione",
                $scope.raccoltaInfo.datiSocietari.fatturazione.comune
              );
            }
          }

          $scope.raccoltaInfo.datiSocietari.updateFromCerved = true;
        }

        var input = {
          appCustomerUser: {
            identifier: $scope.raccoltaInfo.datiSocietari.piva,
            metadata: {
              riUserG: $scope.raccoltaInfo.datiSocietari
            }
          }
        };

        HttpService.send("/user/updateMetadataCustomerUser", input, false).then(
          function (response) {
            if (response.success) {}
          }
        );

        self.nextStepIsEnabled = $scope.change();
        $scope.cervedData = null;
        self.cervedUpdate = 0;
      };

      /**
       * Component - custom events - dropdown
       **/
      self.getLegalStatusDescription = function (legalStatusCode) {
        if ($scope.dropdown.legalStatuses && legalStatusCode) {
          var result = $scope.dropdown.legalStatuses.find(function (legalStatus) {
            return legalStatus.id == legalStatusCode.toUpperCase();
          });
          return result ? result.description : "-";
        } else return "-";
      };

      self.getSaeDescription = function (saeCode, saeFromCerved) {
        if (saeFromCerved) {
          if ($scope.dropdown.saeFromCerved) {
            var result = $scope.dropdown.saeFromCerved.find(function (sae) {
              return sae.id == saeCode;
            });
            return result ? result.description : "-";
          } else return "-";
        } else {
          if ($scope.dropdown.sae) {
            var result = $scope.dropdown.sae.find(function (sae) {
              return sae.id == saeCode;
            });
            return result ? result.description : "-";
          } else return "-";
        }
      };

      self.getRaeDescription = function (raeCode, raeFromCerved) {
        if (raeFromCerved) {
          if ($scope.dropdown.raeFromCerved) {
            var result = $scope.dropdown.raeFromCerved.find(function (rae) {
              return rae.id == raeCode;
            });
            return result ? result.description : "-";
          } else return "-";
        } else {
          if ($scope.dropdown.rae) {
            var result = $scope.dropdown.rae.find(function (rae) {
              return rae.id == raeCode;
            });
            return result ? result.description : "-";
          } else return "-";
        }
      };

      self.getCities = function (field, provincia) {
        if (provincia && provincia != "EE") {
          $scope.citiesList[field] = $scope.mapComuni.filter(function (comune) {
            return comune.sigla == provincia;
          });
        } else if (provincia === "EE") {
          $scope.citiesList[field] = [];
          $scope.capList[field] = [];
          $scope.raccoltaInfo.datiSocietari[field].stato = "";
          console.log(
            "GETCITIES - EE - ",
            $scope.raccoltaInfo.datiSocietari[field]
          );
        }
      };

      self.getCaps = function (field, comune) {
        if (comune) {
          if (
            !$scope.raccoltaInfo.datiSocietari[field] ||
            ($scope.raccoltaInfo.datiSocietari[field] &&
              $scope.raccoltaInfo.datiSocietari[field].provincia != "EE")
          ) {
            $scope.capList[field] =
              $scope.mapComuni.find(function (el) {
                return el.nome.toUpperCase() === comune.toUpperCase();
              }) || [];
            if ($scope.capList[field].cap) {
              $scope.capList[field] = $scope.capList[field].cap;
            }
          }
        }
      };

      self.setNation = function (field, nation) {
        console.log("setNation - FIELD=" + field + " NATION=" + nation);
        if (nation !== "ITALIA") {
          $scope.raccoltaInfo.datiSocietari[field].provincia = "EE";
          $scope.citiesList[field] = [];
          $scope.raccoltaInfo.datiSocietari[field].comune = "";
          $scope.capList[field] = [];
          $scope.raccoltaInfo.datiSocietari[field].cap = "";
        }
      };

      /**
       * Component - custom events
       **/
      //$scope.initCtrl = function() {};    // Toto: - remove
      $scope.change = function () {
        // Used for each field change
        var user = Object.assign({}, $scope.raccoltaInfo.datiSocietari);
        if (
          user.cf &&
          user.emailPec &&
          //&& $scope.configObj.telPrefix
          //&& user.telefono

          user.formaGiuridica &&
          //&& user.ccia
          user.sae &&
          user.rae &&
          user.sedeLegale.indirizzo &&
          user.sedeLegale.numeroCivico &&
          user.sedeLegale.provincia &&
          user.sedeLegale.comune &&
          user.sedeLegale.cap &&
          user.sedeLegale.stato &&
          user.sedeConsegna.indirizzo &&
          user.sedeConsegna.numeroCivico &&
          user.sedeConsegna.provincia &&
          user.sedeConsegna.comune &&
          user.sedeConsegna.cap &&
          user.sedeConsegna.stato &&
          user.fatturazione.indirizzo &&
          user.fatturazione.numeroCivico &&
          user.fatturazione.provincia &&
          user.fatturazione.comune &&
          user.fatturazione.cap &&
          user.fatturazione.stato
        ) {
          self.onClientDataNewOk({
            clientData: user
          }); // $scope.financialModel = Object.assign($scope.financialModel, { clientData: $scope.clientData });
        } else {
          self.onClientDataNewNotOk(); // $scope.financialModel = Object.assign($scope.financialModel, { clientData: null });
        }
        console.log("nextStepIsEnabled", self.nextStepIsEnabled);
      };

      self.onComplete = function () {
        // Used for return the clientData after cerved update
        console.info("onComplete - ClientDataNew");
        $scope.completed = true;
        return $scope.raccoltaInfo.datiSocietari; // $scope.raccoltaInfo.datiSocietari = self.clientDataNew; // Todo: rename $scope.raccoltaInfo.datiSocietari to self.clientDataNew   // Todo: remove - test
      };

      /**
       * Old code (da vedere)
       **/
      console.log("$scope.financialModel", $scope.financialModel);

      $scope.dropdown = {};

      self.$cervedService = $cervedService;
      self.$searchUserService = $searchUserService;
      $scope.$featureService = $featureService;
      //$scope.giuridicVersion = $giuridicVersion; // Todo: remove
      //$scope.today = moment(new Date()).format("DD/MM/YYYY"); // Todo: remove
      //$scope.es6Factory = es6Factory; // Todo: remove
      //$scope.validationService = validationService; // Todo: remove

      $scope.loadingStatus = {
        // Todo: valutare se rimuovere
        loading: false
      };
      $scope.raccoltaInfo = {};
      //$scope.raccoltaInfo = self.clientDataNew || null; // EDF - Add
      //$scope.financialModel = {};   // EDF - Add
      //$scope.raccoltaInfo.datiSocietari = self.clientDataNew || null; // EDF - Add

      self.toJson = function () {
        var args = Array.from(arguments);
        console.log("arguments", arguments);
        var obj = {};
        args.forEach(function (arg, index) {
          if (index % 2 === 0) {
            obj[arg] = args[index + 1];
          }
        });
        /*
                args.reduce(function(a,b){
                    obj[a] = b;
                },0);*/
        var output = JSON.stringify(obj);
        return output;
      };

      self.canConfirmAddress = function () {
        return (
          $scope.raccoltaInfo.datiSocietari.listExtIndirizzi &&
          $scope.raccoltaInfo.datiSocietari.listExtIndirizzi.some(function (addr) {
            return addr.selected == true;
          })
        );
      };

      self.saveAddress = function (field) {
        var address = $scope.raccoltaInfo.datiSocietari.listExtIndirizzi.find(
          function (el) {
            return el.selected;
          }
        );
        $scope.raccoltaInfo.datiSocietari[field].indirizzo = address.indirizzo;
        $scope.raccoltaInfo.datiSocietari[field].numeroCivico =
          address.numeroCivico;
        if (address.provincia) {
          $scope.raccoltaInfo.datiSocietari[field].provincia = address.provincia;
          self.getCities(field, address.provincia);
        } else {
          $scope.raccoltaInfo.datiSocietari[field].provincia = "";
        }
        if (address.comune) {
          $scope.raccoltaInfo.datiSocietari[field].comune = $scope.citiesList[
            field
          ].find(function (el) {
            return el.nome.toUpperCase() === address.comune.toUpperCase();
          }).nome;
          self.getCaps(field, address.comune);
        } else {
          $scope.raccoltaInfo.datiSocietari[field].comune = "";
        }
        $scope.raccoltaInfo.datiSocietari[field].cap = address.cap || "";
        $scope.raccoltaInfo.datiSocietari[field].stato = address.stato || "";
        setTimeout(function () {
          $(".select2").select2();
        }, 100);
      };

      self.selectAddress = function (objIndex) {
        $scope.raccoltaInfo.datiSocietari.listExtIndirizzi.map(function (
          addr,
          index
        ) {
          if (index != objIndex) return (addr.selected = false);
        });
        $scope.raccoltaInfo.datiSocietari.listExtIndirizzi[
            objIndex
          ].selected = !$scope.raccoltaInfo.datiSocietari.listExtIndirizzi[objIndex]
          .selected;
      };

      self.initCtrl = function () {
        return;
      };

      self.requiredCerved = function () {
        //var identifier = self.identifier;
        $searchUserService
          .requiredSyncCerved($scope.raccoltaInfo.datiSocietari.piva) // self.identifier // piva o cf // ex FactoryObj.simulationItem.identifierAppCustomer
          .then(function (success) {
            if (success) {
              console.log("cerved update needed!");
              $modalService.openModal("refreshCervedData");
            } else {
              console.log("cerved update NOT needed! skipping.. ");
            }
          });
      };

      $scope.validationObj = {
        documentDate: {
          disabledDays: [0],
          disabledDates: [
            "01-01",
            "06-01",
            "25-04",
            "01-05",
            "02-06",
            "15-08",
            "01-11",
            "08-12",
            "25-12",
            "26-12"
          ]
        },
        regex: {
          documentNumber: /.+/
        }
      };

      //self.getTodaysDate = function() { // Todo: remove
      //  return moment().format("DD/MM/YYYY");
      //};

      self.isDateValid = function (date) {
        if (date) {
          var date = date.split("/");
          date = date[0] + "-" + date[1];
          if (
            $scope.validationObj.documentDate.disabledDates.indexOf(date) != -1
          ) {
            $('input[name="dataRilascio"]')
              .eq(0)
              .addClass("has-error");
          } else {
            $('input[name="dataRilascio"]')
              .eq(0)
              .removeClass("has-error");
          }
        }
      };

      self.verifyUserGAddress = function () {};

      /************************************************************
       *  VIEW-RI
       ************************************************************/

      self.discardUpdatedData = function () {
        self.cervedUpdate = 0;
        $scope.cervedData = null;
      };

      self.userAlreadyAdded = function (pf) {};

      self.getNsilDocument = function (type, cf) {};
      self.saveDocumentData = function (pf) {};

      self.discardChanges = function (pf) {
        self.cervedUpdate = 1;
      };

      self.isForeignCf = function (cf) {
        return cf.substr(11, 1) == "Z";
      };

      self.check = function (el) {
        el.selected = !el.selected;
      };

      //////////////////// 09/10/2018 - dropdown.stati

      self.isErrorNation = function () {
        console.log(
          "isErrorNation - $scope.raccoltaInfo.datiSocietari.fatturazione.provincia=" +
          $scope.raccoltaInfo.datiSocietari.fatturazione.provincia
        );
        console.log(
          "isErrorNation - $scope.raccoltaInfo.datiSocietari.fatturazione.stato=" +
          $scope.raccoltaInfo.datiSocietari.fatturazione.stato
        );

        if (
          $scope.raccoltaInfo.datiSocietari.sedeConsegna.provincia == "EE" &&
          $scope.raccoltaInfo.datiSocietari.sedeConsegna.stato == "ITALIA"
        ) {
          return true;
        }
        if (
          $scope.raccoltaInfo.datiSocietari.sedeConsegna.provincia != "EE" &&
          $scope.raccoltaInfo.datiSocietari.sedeConsegna.stato != "ITALIA"
        ) {
          return true;
        }

        if (
          $scope.raccoltaInfo.datiSocietari.fatturazione.provincia == "EE" &&
          $scope.raccoltaInfo.datiSocietari.fatturazione.stato == "ITALIA"
        ) {
          return true;
        }
        if (
          $scope.raccoltaInfo.datiSocietari.fatturazione.provincia != "EE" &&
          $scope.raccoltaInfo.datiSocietari.fatturazione.stato != "ITALIA"
        ) {
          return true;
        }

        return false;
      };

      self.getLegalStatuses = function () {
        HttpService.send("/uni/nsil/getAllLegalStatus", {}, false).then(function (
          response
        ) {
          console.log("getAllLegalStatus response", response);
          if (response.success) {
            $scope.dropdown.legalStatuses = response.listAppNsilLglStatus
              .slice()
              .filter(function (el) {
                return el.status === 0;
              });
          }
        });
      };

      self.getSaeList = function (clearFields, formaGiuridica, fromCerved) {
        var input = {
          appNsilLglStatus: {
            id: formaGiuridica
          }
        };

        HttpService.send("/uni/nsil/getSaeByLegalStatus", input, false).then(
          function (response) {
            console.log(response);
            if (response.success) {
              if (clearFields) {
                $scope.raccoltaInfo.datiSocietari.sae = "";
                $scope.raccoltaInfo.datiSocietari.rae = "";
              }

              if (fromCerved) {
                $scope.dropdown.saeFromCerved = response.listAppNsilSae
                  .slice()
                  .filter(function (el) {
                    return el.status === 0;
                  });
                if ($scope.cervedData.appCustomerUser.metadata.riUserG.sae) {
                  self.getRaeList(
                    false,
                    $scope.cervedData.appCustomerUser.metadata.riUserG.sae,
                    true
                  );
                }
              } else {
                $scope.dropdown.sae = response.listAppNsilSae
                  .slice()
                  .filter(function (el) {
                    return el.status === 0;
                  });
                self.getRaeList(
                  false,
                  $scope.raccoltaInfo.datiSocietari.sae,
                  false
                );
              }
            }
          }
        );
      };

      self.getRaeList = function (clearFields, sae, fromCerved) {
        if (clearFields) {
          $scope.raccoltaInfo.datiSocietari.rae = "";
        }
        var input = {
          appNsilSae: {
            id: sae
          }
        };
        HttpService.send("/uni/nsil/getRaeBySae", input, false).then(function (
          response
        ) {
          console.log(response);
          if (response.success) {
            if (fromCerved) {
              $scope.dropdown.raeFromCerved = response.listAppNsilRae
                .slice()
                .filter(function (el) {
                  return el.status === 0;
                });
            } else {
              $scope.dropdown.rae = response.listAppNsilRae
                .slice()
                .filter(function (el) {
                  return el.status === 0;
                });
            }
          }
        });
      };

      self.getFromDomain = function (table, value, list, delay, cb) {
        $timeout(function () {
          HttpService.send(
            "/uni/typedomain/getDomainSet", {
              table: table,
              column: value
            },
            false
          ).then(function (response) {
            if (list) {
              $scope.dropdown[list] = response.domainList;
            }

            if (cb) {
              cb(response);
            }
          });
        }, delay);
      };

      /************************************************************
       * VIEW-RI-01
       ************************************************************/

      self.isPepNotMatching = function () {};

      self.hasBlacklistedPf = function () {};

      /** This method is called after the FINAL insert Contract **/
      self.insertBank = function () {};
    }
  });